import { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'
import { apiFetch } from '@/lib/apiFetch'

export default function InviteAcceptPage() {
  const { user, loading, refresh } = useAuth()
  const history = useHistory()
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const token = params.get('token')

  const [accepting, setAccepting] = useState(false)
  const [error, setError] = useState('')
  const [done, setDone] = useState(false)

  useEffect(() => {
    if (loading) return
    if (!user) {
      history.replace(`/login?redirect=${encodeURIComponent('/invite?token=' + token)}`)
      return
    }
    if (user.type !== 'parent') {
      setError('Please log in with a parent account to accept this invite.')
      return
    }
    if (!token) {
      setError('No invitation token found.')
      return
    }

    const accept = async () => {
      setAccepting(true)
      try {
        await apiFetch('/families/accept-invite', {
          method: 'POST',
          body: JSON.stringify({ token }),
        })
        await refresh()
        setDone(true)
        setTimeout(() => history.push('/settings'), 2000)
      } catch (err: any) {
        setError(err.message || 'Failed to accept invite.')
      } finally {
        setAccepting(false)
      }
    }

    accept()
  }, [loading, user, token])

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center space-y-4">
        <h1 className="text-2xl font-bold">Family Invitation</h1>
        {loading || accepting ? (
          <p className="text-muted-foreground">Accepting invitation...</p>
        ) : error ? (
          <div className="space-y-4">
            <p className="text-red-600">{error}</p>
            <button
              onClick={() => history.push('/settings')}
              className="text-sm px-4 py-2 bg-primary text-primary-foreground rounded-lg font-medium hover:opacity-90 transition"
            >
              Go to Settings
            </button>
          </div>
        ) : done ? (
          <p className="text-primary font-medium">
            Invitation accepted! Redirecting to settings...
          </p>
        ) : null}
      </div>
    </div>
  )
}
